























































import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import { getUserList } from '../api';
import { isWeiXin } from '@/common/ts/common';
Vue.use(List);
@Component
export default class User extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  async created() {
    const isLogin = window.gettoken() && window.gettoken() !== 'null';
    const unionid = window.localStorage.getItem('unionid');
    if (window.udid && !isLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
      return false;
    } else if (isWeiXin() && !unionid) {
      this.WechatLogin();
    }
  }
  WechatLogin() {
    if (isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  onLoad() {
    const data = {
      udid: window.udid,
      appkey: window.appkey,
      token: window.gettoken(),
      unionid: window.localStorage.getItem('unionid'),
      page: this.page,
    };
    getUserList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
}
